import { RecurType } from 'mbs-ui-shared@models/RecurType.enum';
import moment from 'moment';
import { DayOfWeek } from 'wizards/models/DayOfWeek.enum';
import { WeekNumber } from 'wizards/models/WeekNumber.enum';
import { ScheduleType } from './schedule-type.enum';

export class DailyFrequency {
  PeriodOption: string = undefined;
  OccursAtTime: string;
  OccursEveryCount: number;
  OccursEveryPeriod: string = undefined;
  OccursEveryFromTime: string = undefined;
  OccursEveryToTime: string = undefined;
  OccursEveryDuration: moment.Duration = undefined;
  RepeatEveryCount?: number = undefined;
  StartFromDate?: Date | string;
  constructor(isLinux = false) {
    this.OccursEveryDuration = moment.duration(0);
    if (!isLinux) {
      this.StartFromDate = moment().format('YYYY-MM-DDT00:00:00');
    }
    this.OccursAtTime = moment().format('HH:mm:ss');
    this.OccursEveryCount = 1;
  }
}

export class WeeklyFrequency {
  DaysOfWeek: DayOfWeek[];
  RepeatEveryCount?: number;
  StartFromDate?: Date;
  constructor() {
    this.DaysOfWeek = [];
  }
}

export class MonthlyFrequency {
  OccurrencePeriod: WeekNumber;
  DayOfWeek: DayOfWeek;
  RepeatEveryCount?: number;
  StartFromDate?: Date;
  DayOfMonthCount: number;
}

export class YearlyFrequency {
  RepeatEveryCount: number;
  StartFromDate: Date;
}

export class RecurringSchedule {
  RecurringPeriod: RecurType;
  DailyFrequency: DailyFrequency;
  WeeklyFrequency: WeeklyFrequency;
  MonthlyFrequency: MonthlyFrequency;
  YearlyFrequency?: YearlyFrequency;
  constructor(isLinux = false) {
    this.RecurringPeriod = RecurType.Daily;
    this.DailyFrequency = new DailyFrequency(isLinux);
    this.WeeklyFrequency = new WeeklyFrequency();
    this.MonthlyFrequency = new MonthlyFrequency();
    if (!isLinux) this.YearlyFrequency = new YearlyFrequency();
  }
}

export class SpecificDateSchedule {
  OnceDate: Date;
  constructor() {
    this.OnceDate = new Date();
  }
}

export class ScheduleModel {
  ScheduleType: ScheduleType;
  SpecificDateSchedule: SpecificDateSchedule;
  RecurringSchedule: RecurringSchedule;
  constructor() {
    this.ScheduleType = ScheduleType.noschedule;
    this.SpecificDateSchedule = new SpecificDateSchedule();
    this.RecurringSchedule = new RecurringSchedule();
  }
}
